import $ from 'jquery';
import BasePropertyView from 'BasePropertyView'
import printNameTemplate from 'properties/main/print-file-name.ejs';
import constants from 'Constants.js';

const SILENT = constants.MODEL_SILENT;

class MainButtonTypeView extends BasePropertyView {

    initialize( opts ) {

        super.initialize( opts );
        this.options = opts || {};
        this.template = printNameTemplate;
        this.tagName = 'div';
        this.id = opts.el;
        this.config = opts.config || {};

        // PF-8438
        if (!this.model.get('printFileName')) {
            this.model.set('printFileName', 'print', SILENT);
        }

        this.events = {
            'change #printFileName' : 'updateAttributes'
        };

        return this;
    }

    updateAttributes(ev) {
        ev.preventDefault();

        const propName = ev.currentTarget.name;
        // Remove special chars
        const propVal  = ev.currentTarget.value.replace(/[^a-zA-Z0-9 ]/g, "");
        
        this.model.set( propName, propVal );
    }

    render() {
        super.render();
        this.$el.empty();
        if(this.template) {
            this.$el.html(this.template(this.model.toJSON()));
        }

        this.delegateEvents();

        return this;
    }
}

export default MainButtonTypeView;